import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div
      data-testid="checkout-cancel-page"
      className="max-w-2xl mx-auto px-6 md:px-12 py-24 md:py-32 text-center"
    >
      <XCircle className="w-12 h-12 mx-auto text-[#5B5653]" />
      <p className="label-eyebrow mt-8">Cancelled</p>
      <h1 className="font-serif text-4xl mt-4 text-[#2D2926] font-light">
        Your payment was cancelled
      </h1>
      <p className="text-[#5B5653] mt-4">No charge was made. The artwork is still available.</p>
      <Link to="/checkout" className="btn-primary mt-10 inline-flex">
        Try Again
      </Link>
    </div>
  );
}
